import React from 'react'
import { GridCell, Grid } from 'common-controls/Core/index'

import styles from './ViewLayout.less'

export function ViewLayoutBody (props) {
  const { children, customLayout, blue, blockContainer = false, style = {} } = props
  const color = blue ? 'blue' : 'teal'
  return <GridCell auto blockContainer style={style} className={`slide-pane-content-${color}` + ' ' + styles.relativePosition}>
    {children}
  </GridCell>
}

export default ViewLayoutBody
